export default __webpack_public_path__ + "static/media/Dentists.af9195f8.png";